import React, { FunctionComponent } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import {
  createCompanyToolsCategory,
  updateCompanyToolsCategory,
} from '../../../../app/page/page-storage/company-tools-categories/company-tools-categories.actions';
import { ICompanyToolsCategoryCreateForm } from '../../../../app/resource/company-tools-category/company-tools-category.types';
import { useRequiredValidation } from '../../../../utils/form/validation.utils';
import { AvatarInput } from '../../common/inputs/AvatarInput';
import { ColorInput } from '../../common/inputs/ColorInput';
import { FormTextInput } from '../../common/inputs/TextInput';
import { FormTextAreaInput } from '../../common/inputs/TextAreaInput';
import { ICompanyToolsCategoryFormProps } from './types';

export const CompanyToolsCategoryForm: FunctionComponent<ICompanyToolsCategoryFormProps> = ({ data }) => {
  const dispatch = useDispatch();
  const formProps = useForm<ICompanyToolsCategoryCreateForm>();
  const requiredValidation = useRequiredValidation();

  const onSubmit = (formData: ICompanyToolsCategoryCreateForm) => {
    const payload = {
      title: formData.title,
      color: formData.color,
      description: formData.description ?? '',
    };

    if (data?.id) {
      dispatch(updateCompanyToolsCategory(data.id, payload));
    } else {
      dispatch(createCompanyToolsCategory(payload));
    }
  };

  return (
    <FormProvider {...formProps}>
      <form
        id="company-tools-category-form"
        className="topic-form"
        onSubmit={formProps.handleSubmit(onSubmit)}
        action=""
        method="post"
      >
        <div className="col-12" style={{ marginTop: '10px' }}>
          <div className="field-container">
            <FormTextInput
              id="title"
              name="title"
              type="text"
              label="Title (*)"
              placeholder="Enter category title"
              defaultValue={data?.title ?? ''}
              validation={requiredValidation}
            />
          </div>
        </div>
        <div className="col-12">
          <div className="field-container">
            <FormTextAreaInput
              id="description"
              name="description"
              label="Description"
              placeholder="Enter category description"
              defaultValue={data?.description ?? ''}
              rows={4}
            />
          </div>
        </div>
        <div className="popup-upload-panel">
          <ColorInput
            id="color"
            name="color"
            placeholder="Category Color *"
            validation={requiredValidation}
            defaultValue={data?.color}
          />
        </div>
        <div className="popup-upload-panel">
          <AvatarInput
            id="avatar"
            name="avatar"
            label="Upload category image"
            defaultValue={data?.avatar ?? undefined}
            maxImageSize={5}
            acceptableFormats="jpg, gif, png, webp"
          />
        </div>
        <div className="col-12 mt-2">
          <div className="darkGray">(*) mandatory fields</div>
        </div>
      </form>
    </FormProvider>
  );
};
